import { Category } from "common/app/command-palette/types";

function getTranslations() {
  return {
    menu: _("Menu"),
    "account-settings": _("Account Settings"),
    action: _("Action"),
    entity: _("Entity"),
    navigation: _("Navigation"),
    form: _("Form"),
    "entity-settings": _("Entity Settings"),
    uncategorized: _("Uncategorized"),
    report: _("Report"),
  };
}

const CATEGORY_TRANSLATIONS: Record<Category, string> = getTranslations();

// Cache translations for better performance
const translationCache = new Map<string, string>();

export function translateCategory(category: Category): string {
  if (!category) return "";

  // Use cached translation if available
  if (translationCache.has(category)) {
    return translationCache.get(category);
  }

  const translation = CATEGORY_TRANSLATIONS[category] || category;
  translationCache.set(category, translation);
  return translation;
}
